module.exports = __webpack_public_path__ + "efca2b7b3ae8db58065b935e9b053eca.ttf";